import React, { useEffect, useState } from "react";
import {
  Box,
  createStyles,
  Flex,
  Grid,
  Tabs,
  Text,
  Title,
  Button,
} from "@mantine/core";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";
import {
  getDashboardCounts,
  getPendingNotes,
  getStaffDashboardCounts,
  getTodaysMAR,
  getTodaysNotes,
  getTodaysTasks,
} from "../../../services/dashboard";
import { getAllStaff } from "../../../services/staff";
import { getAllNoteTypes, getNotes } from "../../../services/note";
import {
  getAllFacilitiesModal,
  getAllFacilityTypes,
  getBillingCache,
} from "../../../services";
import { getAllPatientsModal } from "../../../services/patient";
import { TrackPageView } from "../../../config/mixpanelConfig";
import { StaffSvg } from "../../../components/Svgs/StaffSvg";
import { NoteSvg } from "../../../components/Svgs/NoteSvg";
import { ReportSvg } from "../../../components/Svgs/ReportSvg";
import { DashTable } from "../../../components/DashTable";
import { IconCalendar } from "@tabler/icons-react";
import { rem } from "@mantine/core";
import PendingAction from "./PendingAction";
import DashboardAnalytics from "../../../components/DashboardAnalytics";
import StaffGreetings from "../../../components/StaffGreetings";
import DashboardTimer from "../../../components/DashboardTimer";
import { TaskDashTable } from "../../../components/DashTable/taskDashTable";
import { MARDashTable } from "../../../components/DashTable/marDashTable";
import DashboardDateComponent from "../../../components/DashboardDateComponent";
import moment from "moment";
import { useDisclosure } from "@mantine/hooks";
import DashboardCards from "../../../components/DashboardCards/DashboardCards";
import { ClientSvg } from "../../../components/Svgs/ClientSvg";
import BlueInfoSvg from "../../../components/Svgs/BlueInfoSvg";
import { RxCross1 } from "react-icons/rx";
import {
  getNotifications,
  getNotificationsCount,
} from "../../../services/notification";
import AttendanceModal from "../../../containers/StaffModal/AttendanceModal";
import { getAllAttendenceStaff } from "../../../services/staff";
import UploadStaffDocDashboard from "../../../components/StaffDetails/UploadStaffDocDashboard";
import { TbClockHour1 } from "react-icons/tb";
import { getExpiredFiles } from "../../../services/Document";
import { getAllSignatures } from "../../../services/signature";
import { decrypt } from "../../../utils";
const useStyles = createStyles(() => ({
  dashboard: {
    width: "100%",
    backgroundColor: "#f5f5f5",
  },
  tableContainer: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    // margin: "1rem",
  },
  tab_list: {
    width: "fit-content !important",
    "& .mantine-Tabs-tabsList": {},
  },
  overviewHeading: {
    fontFamily: "Inter",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0%",
    color: "#171717",
    "@media (max-width:768px)": {
      textAlign: "center",
      marginBottom: "0",
    },
  },
  clockInText: {
    borderRadius: "8px",
    border: "1px solid  #E4E4E7",
    background: "#FFF",
    padding: "12px",
    margin: "15px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "5px",
  },
  workLogBtn: {
    margin: "0 1rem 0 .5rem",
    borderRadius: "7px",
    background: "#fff",
    color: "#262626",
    outline: "1px solid #D4D4D4",
  },
}));
const NewDashboard = ({ isSidebarOpen }) => {
  const { classes } = useStyles();
  const { dashboardCounts, staffDashboardCounts, staffLoadingCount } =
    useSelector((state) => state.dashboard);
  const { selectedDocModal } = useSelector((state) => state?.document);
  const { profile } = useSelector((state) => state?.profile);
  const { allFacilities } = useSelector((state) => state?.facility);
  const { allPatients } = useSelector((state) => state?.patient);
  const [opened, { close, open }] = useDisclosure(false);
  const [dateRange, setDateRange] = useState({
    type: null,
    date: [
      moment().subtract(1, "month").startOf("day").toDate(),
      moment().endOf("day").toDate(),
    ],
  });
  const [mode, setmode] = useState("view");
  const [range, setRange] = useState([
    moment(dateRange?.date?.[0]),
    moment(dateRange?.date?.[1]),
  ]);
  const [refresh, setRefresh] = useState(false);
  const [isStaffModalOpen, { open: openStaffModal, close: closeStaffModal }] =
    useDisclosure(false);

  const icon = (
    <IconCalendar
      style={{ width: rem(18), height: rem(18), color: "#000000" }}
      stroke={1.5}
    />
  );

  let startDate = moment().startOf("day").toISOString();
  let endDate = moment().endOf("day").toISOString();

  const [startTime, setStartTime] = useState(null); // For start time
  const [endTime, setEndTime] = useState(null); // For end time
  const [userTracking, setUserTracking] = useState(null);
  const [showInfo, setShowInfo] = useState(null);
  const [showClockIn, setShowClockIn] = useState(false);
  const [staffNotSee, setStaffNotSee] = useState([]);
  const [staffAdminNotSee, setStaffAdminNotSee] = useState([]);

  const DEFAULT_STAFF_NOT_SEE = []; // Add default hidden items if any

  useEffect(() => {
    getStaffDashboardCounts(dateRange);
    getAllSignatures();
    getNotifications({
      page: 1,
      perPage: 10,
      client: "",
    });
  }, []);

  const handleApply = () => {
    getStaffDashboardCounts(dateRange);
    close();
  };

  useEffect(() => {
    let newDate = new Date();
    let newDateString = newDate.toISOString().slice(0, 10);
    localStorage.setItem("calendar_date", `daily_${newDateString}`);

    getPendingNotes();
    getTodaysNotes();
    // getNotes();
    getTodaysTasks("", startDate, endDate);
    getTodaysMAR();
    getDashboardCounts();
    getAllStaff("all");
    getAllNoteTypes();
    getAllFacilityTypes();
    getAllFacilitiesModal();
    getAllPatientsModal();
    getBillingCache();
    getExpiredFiles();

    TrackPageView("Dashboard");
  }, []);

  const attendenceStaff = async () => {
    try {
      // setLoading(true)
      await getAllAttendenceStaff(1, range);
    } catch (e) {
      console.log("🚀 ~ attendenceStaff ~ e:", e);
    }
    // finally{
    //   setLoading(false)
    // }
  };

  useEffect(() => {
    attendenceStaff();
  }, [range]);

  useEffect(() => {
    const permissions = profile?.user?.permissions;
    const role = profile?.user?.role;

    if (!role && !profile?.user?.type) {
      setStaffAdminNotSee([]);
      return;
    }

    if (role === "admin" && (!permissions || typeof permissions !== "object")) {
      setStaffAdminNotSee([]);
      return;
    }

    const hiddenFields = Object.entries(permissions || {})
      .filter(([key, value]) => key !== "aiAccess" && value === false)
      .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1));

    if (role === "admin") {
      setStaffAdminNotSee(hiddenFields);
    } else if (role === "staff") {
      const combined = [...DEFAULT_STAFF_NOT_SEE, ...hiddenFields];
      setStaffNotSee([...new Set(combined)]);
    }
  }, [profile?.user?.permissions]);

  const canView = (tab) =>
    !staffNotSee.includes(tab) && !staffAdminNotSee.includes(tab);

  return (
    <Box className={classes.dashboard}>
      <AppNavbar
        title="Dashboard"
        profile={profile}
        isSidebarOpen={isSidebarOpen}
      />
      <Box pl={6}>
        {profile?.user?.type === "staff" && (
          <>
            <StaffGreetings
              userName={profile?.user?.name ? profile?.user?.name : "staff"}
              text="Excited to be here... Get your activities in real time"
            />
          </>
        )}
        <Flex align={"center"} justify="flex-end" mt={20} mr={20} gap={5}>
          <img src={"/assets/images/ghari.png"} alt="" width={25} height={25} />
          <Button
            onClick={() => openStaffModal("view")}
            className={classes.workLogBtn}
            variant="outline"
          >
            Work Log
          </Button>
          {profile?.user?.type !== "staff" && (
            <Button
              onClick={() => setShowClockIn(true)}
              color="yellow"
              c={"#000"}
              variant="filled"
              leftIcon={<TbClockHour1 size={20} />}
            >
              Clock-in
            </Button>
          )}
        </Flex>
        {/* Staff Clock-in/out  */}
        {(showClockIn || profile?.user?.type === "staff") && (
          <DashboardTimer
            startTime={startTime}
            setStartTime={setStartTime}
            endTime={endTime}
            setEndTime={setEndTime}
            userTracking={userTracking}
            setUserTracking={setUserTracking}
            setShowInfo={setShowInfo}
            setShowClockIn={setShowClockIn}
          />
        )}
        {showInfo && userTracking && (
          <Box className={classes.clockInText}>
            {" "}
            <Flex align={"center"} gap={1}>
              <BlueInfoSvg />
              You’ve clocked in as{" "}
              {(profile?.user?.type === "staff"
                ? profile?.user?.facilityId?.find(
                    (f) => f?.id === userTracking?.facility
                  )?.name
                : allFacilities?.facilities?.find(
                    (f) => f?.id === userTracking?.facility
                  )?.name) ||
                allPatients?.find((p) => p?.id === userTracking?.client)
                  ?.name ||
                ""}{" "}
              {/* {profile?.user?.type === "staff"
                ? profile?.user?.facilityId?.find(
                    (_f) => _f?.id === userTracking?.facility
                  )?.name ||
                  allPatients?.find((_p) => _p?.id === userTracking?.client)
                    ?.name
                : allFacilities?.facilities?.find(
                    (_f) => _f?.id === userTracking?.facility
                  )?.name ||
                  allPatients?.find((_f) => _f?.id === userTracking?.client)
                    ?.name}{" "} */}
              at{" "}
              {startTime
                ? moment(userTracking?.startTime).format("hh:mm A")
                : ""}
            </Flex>
            <Box
              onClick={() => setShowInfo(false)}
              style={{ cursor: "pointer" }}
            >
              <RxCross1 />
            </Box>
          </Box>
        )}
        {/* Staff Date Filter */}
        <Box className={classes.container}>
          <Flex align={"center"} justify="space-between">
            <Text mt={15} ml={16} className={classes.overviewHeading}>
              Overview
            </Text>
            <Grid m={0} gutter={"xs"} mt={5} justify="end">
              {profile?.user?.type == "staff" &&
                profile?.user?.role == "staff" && (
                  <DashboardDateComponent
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    handleApply={handleApply}
                    open={open}
                    opened={opened}
                    close={close}
                  />
                )}
            </Grid>
          </Flex>
          {/* Staff Data Analytics */}
          {profile?.user?.type == "staff" && profile?.user?.role == "staff" && (
            <DashboardAnalytics
              data={staffDashboardCounts}
              loading={staffLoadingCount}
            />
          )}
          <Grid m={0}>
            <Grid.Col
              xs={12}
              sm={12}
              md={12}
              lg={
                profile?.user?.role == "admin" || profile?.user?.type != "staff"
                  ? 8
                  : 12
              }
            >
              {/* Cards */}
              {(profile?.user?.type != "staff" ||
                profile?.user?.role == "admin") && (
                <Grid m={0}>
                  <Grid.Col xs={12} sm={6} md={6} lg={6}>
                    <DashboardCards
                      icon={<StaffSvg />}
                      title={"Active Staff"}
                      count={dashboardCounts?.staffCount}
                      newCount={dashboardCounts?.staffActiveToday}
                    />
                  </Grid.Col>
                  <Grid.Col xs={12} sm={6} md={6} lg={6}>
                    <DashboardCards
                      icon={<ClientSvg />}
                      title={"Active Client"}
                      count={dashboardCounts?.patientCount}
                      newCount={dashboardCounts?.patientCountToday}
                    />
                  </Grid.Col>
                  <Grid.Col xs={12} sm={6} md={6} lg={6}>
                    <DashboardCards
                      icon={<NoteSvg />}
                      title={"Note Entries"}
                      count={dashboardCounts?.noteCount}
                      newCount={dashboardCounts?.noteCountToday}
                    />
                  </Grid.Col>

                  <Grid.Col xs={12} sm={6} md={6} lg={6}>
                    <DashboardCards
                      icon={<ReportSvg />}
                      title={"Report"}
                      count={dashboardCounts?.reportCount}
                      newCount={dashboardCounts?.reportsCountToday}
                    />
                  </Grid.Col>
                </Grid>
              )}
              {/* Table */}
              <Title my={10} ml={15} className={classes.overviewHeading}>
                All Activities
              </Title>
              <Grid gutter={"xl"} m={10} className={classes.tableContainer}>
                <Grid.Col xs={12} md={12} lg={12} xl={12}>
                  <Tabs
                    color="gray"
                    defaultValue="note"
                    className={classes.tabs}
                  >
                    <Tabs.List className={classes.tab_list}>
                      {canView("Note") && (
                        <Tabs.Tab value="note">Note</Tabs.Tab>
                      )}
                      {canView("Task") && (
                        <Tabs.Tab value="task">Task</Tabs.Tab>
                      )}
                      {canView("Medication") && (
                        <Tabs.Tab value="mar">MAR</Tabs.Tab>
                      )}
                    </Tabs.List>

                    {canView("Note") && (
                      <Tabs.Panel value="note">
                        <DashTable />
                      </Tabs.Panel>
                    )}
                    {canView("Task") && (
                      <Tabs.Panel value="task">
                        <TaskDashTable
                          startDate={startDate}
                          endDate={endDate}
                        />
                      </Tabs.Panel>
                    )}
                    {canView("Medication") && (
                      <Tabs.Panel value="mar">
                        <MARDashTable />
                      </Tabs.Panel>
                    )}

                    {/* <Tabs.List className={classes.tab_list}>
                      <Tabs.Tab value="note">Note</Tabs.Tab>
                      <Tabs.Tab value="task">Task</Tabs.Tab>
                      <Tabs.Tab value="mar">MAR</Tabs.Tab>
                    </Tabs.List>
                    <Tabs.Panel value="note">
                      <DashTable />
                    </Tabs.Panel>
                    <Tabs.Panel value="task">
                      <TaskDashTable startDate={startDate} endDate={endDate} />
                    </Tabs.Panel>
                    <Tabs.Panel value="mar">
                      <MARDashTable />
                    </Tabs.Panel> */}
                  </Tabs>
                </Grid.Col>
              </Grid>
            </Grid.Col>
            {/* Pending Action Column */}
            {(profile?.user?.type != "staff" ||
              profile?.user?.role == "admin") && (
              <Grid.Col xs={12} sm={12} md={4} lg={4}>
                <PendingAction />
              </Grid.Col>
            )}
          </Grid>
        </Box>
      </Box>
      <AttendanceModal
        mode={mode}
        range={range}
        setRange={setRange}
        refresh={refresh}
        setRefresh={setRefresh}
        title="Work Logs"
        opened={isStaffModalOpen}
        onclose={closeStaffModal}
        selectedItem={profile?.user?.id}
      />
      {selectedDocModal && (
        <UploadStaffDocDashboard
          selectedFolder={selectedDocModal?.folder}
          userId={selectedDocModal?.userId}
          isPendingAction={true}
          uploadedFiles={selectedDocModal}
        />
      )}
    </Box>
  );
};

export default NewDashboard;
